/**
 * Gets list of orders ordered by user.
 * Called from UserInterface.js
 */
var handleError = function (err) {
    console.error(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Network Error'
    }));
};

export default async function getAccountOrders(companyid, period = 0) {
    
  try {

    const { fromDate, toDate } = getPastMonthDateRange(period);
    const startDate = fromDate.getFullYear()+'-'+ ('0'+(fromDate.getMonth()+ 1)).slice(-2) +'-'+('0'+fromDate.getDate()).slice(-2);
    const endDate = toDate.getFullYear()+'-'+ ('0'+(toDate.getMonth()+ 1)).slice(-2) +'-'+('0'+toDate.getDate()).slice(-2);

    const url = process.env.REACT_APP_FIND_API + '/order/list/company?companyid=' + encodeURIComponent(companyid) + '&fromDate=' + encodeURIComponent(startDate) + '&toDate=' + encodeURIComponent(endDate);
    const res = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res || !res.ok) throw new Error('Failed to fetch account orders');
    const data = await res.json();

    return data.orders;
  } catch (err) {
    handleError(err);
    return 0;
  }
}

export function getPastMonthDateRange(monthOffset, today = new Date()) {
  if (!Number.isInteger(monthOffset) || monthOffset < 0 || monthOffset > 11) {
    throw new RangeError('monthOffset must be an integer from 0 to 11');
  }

  const fromDate = new Date(today.getFullYear(), today.getMonth() - monthOffset, 1);
  const toDate = new Date(today.getFullYear(), today.getMonth() - monthOffset + 1, 0);

  return { fromDate, toDate };
}

